<template>
    <div>
      <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
              <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
                v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
              </b-dropdown-item>
              <b-dropdown-item @click="checkDataExcel(json_data)">
                <download-excel :data="json_data" :fields="json_fields" :name="fileName">
                  <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                </download-excel>
              </b-dropdown-item>
              <b-dropdown-item>
                <download-excel :data="dataExport" :fields="json_fields" :name="fileName">
                  <i class="fa fa-file-excel-o mr-1" />Export Excel All
                </download-excel>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a-checkbox @change="getAutoRefresh(refresh)">
                รีเฟรชอัตโนมัติ {{(this.refresh) ? myVal : ''}}
            </a-checkbox>
          </div>
          <div class="d-flex flex-column justify-content-center">
              <a class="btn btn-primary" href="javascript: void(0);" @click="getDataDeposiit()"><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
          </div>
      </div>
      <a-table :columns="columns" :dataSource="dataTable" :loading="isLoading" :row-selection="rowSelection" rowKey='id' :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
        <div
          slot="filterDropdown"
          slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          class="custom-filter-dropdown"
        >
          <a-input
            v-ant-ref="c => searchInput = c"
            :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm)"
            style="width: 188px; margin-bottom: 8px; display: block;"
          />
          <a-button
            type="primary"
            @click="() => handleSearch(selectedKeys, confirm)"
            size="small"
            style="width: 90px; margin-right: 8px"
          >
            Search
          </a-button>
          <a-button
            @click="() => handleReset(clearFilters)"
            size="small"
            style="width: 90px"
          >
            Reset
          </a-button>
        </div>
        <a-icon
          slot="filterIcon"
          slot-scope="filtered"
          type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
      </a-table>
    </div>
  </template>

<script>

import { mapGetters } from 'vuex'
import { getName } from '@/utils/status'
import apiClient from '@/services/api'
// import moment from 'moment'
import Swal from 'sweetalert2'
// import axios from 'axios'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}
export default {
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getProviderId: 'getProviderId',
    }),
    myVal() {
      if (this.ctr === 0) {
        this.reCountdown()
      }
      return this.ctr
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataTable.map((result) => {
                return result.id
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
  },
  watch: {
    getStartDate: function(val) {
      if (val) this.getDataDeposiit()
    },
    getEndDate: function(val) {
      if (val && !this.checkFistPage) {
        this.getDataDeposiit()
      }

      if (this.checkFistPage) this.checkFistPage = false
    },
    getProviderId: function(val) {
      if (val) this.getDataDeposiit()
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
  },

  data() {
    return {
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
      checkFistPage: true,
      selectedRowKeys: [],
      dataExport: [],
      fileName: '',
      json_data: [],
      json_fields: {
        ชื่อเอเจนท์: 'agentName',
        'เติมเงิน/บาท': 'sumDepositAmount',
        'เติมเงิน/ครั้ง': 'countDeposit',
        'ถอนเงิน/บาท': 'sumWithdrawAmount',
        'ถอนเงิน/ครั้ง': 'countWithdraw',
      },
      isLoading: false,
      refresh: false,
      countdown: false,
      timer: '',
      counters: '',
      counters2: '',
      ctr: 5,
      dataTable: [],
      columns: [
        {
          title: 'ชื่อเอเจนท์',
          key: 'agentName',
          dataIndex: 'agentName',
          //   width: 200,
          filters: [],
          onFilter: (value, record) => record.agentName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'เติมเงิน/บาท',
          key: 'sumDepositAmount',
          //   width: 150,
          dataIndex: 'sumDepositAmount',
          customRender: (text, row, index) => {
            return typeof text !== 'undefined' ? text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0.00'
          },
        },
        {
          title: 'เติมเงิน/ครั้ง',
          key: 'countDeposit',
          //   width: 150,
          dataIndex: 'countDeposit',
          customRender: (text, row, index) => {
            return typeof text !== 'undefined' ? text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : 0
          },
        },
        {
          title: 'ถอนเงิน/บาท',
          key: 'sumWithdrawAmount',
          //   width: 150,
          dataIndex: 'sumWithdrawAmount',
          customRender: (text, row, index) => {
            return typeof text !== 'undefined' ? text.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0.00'
          },
        },
        {
          title: 'ถอนเงิน/ครั้ง',
          key: 'countWithdraw',
          //   width: 150,
          dataIndex: 'countWithdraw',
          customRender: (text, row, index) => {
            return typeof text !== 'undefined' ? text.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : 0
          },
        },
      ],
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    copyLink(link) {
      CopyMe(link)
      Toast.fire({ icon: 'success', title: 'success copy' })
    },
    checkDataExcel (data) {
      if (data.length === 0) {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการ Export' })
        return false
      }
    },
    returnData(item) {
      return {
        agentName: item.agentName,
        sumDepositAmount: typeof item.sumDepositAmount !== 'undefined' ? item.sumDepositAmount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0.00',
        countDeposit: typeof item.countDeposit !== 'undefined' ? item.countDeposit.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : 0,
        sumWithdrawAmount: typeof item.sumWithdrawAmount !== 'undefined' ? item.sumWithdrawAmount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0.00',
        countWithdraw: typeof item.countWithdraw !== 'undefined' ? item.countWithdraw.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : 0,
      }
    },
    dataToExcel (data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.id === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          dataresult.push(resultData)
        })
        this.json_data = dataresult
      }
    },
    exportAll (obj) {
      this.dataExport = []
      let resultData = {}
      obj.map(item => {
        resultData = this.returnData(item)
        this.dataExport.push(resultData)
      })
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.id === result) {
              return true
            }
          })
          const resultData = this.returnData(item)
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onError: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    async getDataDeposiit() {
      const dataDeposit = await {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        providerId: this.getProviderId,
      }
      this.isLoading = !this.isLoading
      await apiClient.post('/agentSBO/getDataAgent', dataDeposit).then(response => {
        this.isLoading = !this.isLoading
        const res = response.data
        if (res.code === '000') {
          this.dataTable = res.responseData.data
          this.exportAll(res.responseData.data)
          if (this.dataTable.length > 0) {
            const listProviderSBO = this.dataTable.map(function(item, pos) {
              if (item.providerName !== null) {
                return { text: item.providerName, value: item.providerName }
              }
            })

            this.columns[0].filters = [
              ...new Map(listProviderSBO.map((item) => [item.text, item])).values(),
            ]
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    getStatus(type, status) {
      // console.log(getName(type, status)[0])
      return getName(type, status)[0]
    },
    getAutoRefresh(refresh) {
      if (!refresh) {
        this.refresh = true
        this.ReloadData(true)
      } else {
        this.refresh = false
        this.ReloadData(false)
      }
    },
    ReloadData (value) {
      if (value) {
        this.countdown = true
        this.counters = setInterval(function () {
          this.getDataDeposiit()
        }.bind(this), 5000)
        this.counters2 = setInterval(function () {
          this.ctr = this.ctr - 1
        }.bind(this), 1000)
      } else {
        clearInterval(this.counters)
        clearInterval(this.counters2)
        this.ctr = 5
      }
    },
    reCountdown () {
      this.ctr = 5
    },
  },
  async created() {
    // await this.getDataWithdraw()
  },
}
</script>

  <style>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }

  .badge.badge-custom {
      background: #ff5722;
      color: #fff;
  }
  </style>
